/**
 * @generated SignedSource<<d3b8468461cfb9479a684316caace743>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedSkinnyBannerModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_viewer">;
  readonly " $fragmentType": "HpSharedSkinnyBannerModule_viewer";
};
export type HpSharedSkinnyBannerModule_viewer$key = {
  readonly " $data"?: HpSharedSkinnyBannerModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedSkinnyBannerModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedSkinnyBannerModule_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useCoreBuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1053bde55154a9326d8ba3d930dab384";

export default node;
